'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('./product/quickView'));
    processInclude(require('./product/notifyMe'));
    processInclude(require('./search/filter'));
    processInclude(require('./search/marketingTile'));
});
